import MarkSafe from '../../../../general/components/MarkSafe';

const Metar = ({metars}) => {
    if (metars.length === 0) return null;

    const [{date, text}] = metars;

    return (
        <p className="taf">
            {date} <MarkSafe value={text} />
        </p>
    );
};

export default Metar;
